/**
 * Endereço do relatório de abordagem em PDF.
 *
 * A rota continua sendo `/imprime-abordagem` embora a tela hoje entregue um
 * arquivo: a autorização do sistema é POR ROTA, e é o backend quem concede esta
 * — `virgem/src/app/utils/derivaAcessos.js` a injeta como acesso sintético de
 * quem tem o bloco de abordagem. Renomear no front sozinho faz o PrivateRoute
 * negar a tela ("rota não autorizada"), e renomear nos dois lados amarraria o
 * deploy do front ao do backend: subindo primeiro, ninguém abre o relatório.
 *
 * O nome que o usuário lê é o do botão ("Relatório PDF"), não o da URL.
 */
export const ROTA_RELATORIO = '/imprime-abordagem/:abordagem_id';

export const caminhoDoRelatorio = abordagemId =>
  abordagemId ? `/imprime-abordagem/${abordagemId}` : null;
